import tokens from "common/styles/tokens/exports.less?export";

export const paymentElementAppearanceBase = {
  theme: "flat",
  labels: "floating",
  variables: {
    colorPrimary: tokens.brand,
    colorBackground: tokens.white,
    colorText: tokens["grey-800"],
    colorTextSecondary: tokens["grey-600"],
    colorTextPlaceholder: tokens["grey-400"],
    colorDanger: tokens["danger-500"],
    fontSmooth: "always",
    spacingUnit: tokens["spacing-xs-2"],
  },
  rules: {
    ".Error": {
      color: tokens["danger-500"],
      fontSize: tokens["font-size-xs"],
    },
  },
} as const;
